import { ResponsiveTableRow } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { DmcResponsiveTable, DmcResponsiveCheckboxTable } from '../../common/DmcResponsiveTable'
import { toLocaleString } from '../../../util/DateUtil'
import { CisLink, PersonLink } from '../../app/Links'
import DeleteGroupMembersButton from './DeleteGroupMembersButton'
import DemotePromoteMembersButton from './DemotePromoteMembersButton'
import { PermissionsContext } from '../../app/PermissionsContext'
import { getIdElement } from '../../../util/StringUtil'

export default function GroupMembersList({ groupMembersState, setCheckedMembers, refreshData }) {
  const { t } = useTranslation()
  const { isAuthorized } = useContext(PermissionsContext)
  const admins = groupMembersState?.members?.filter((member) => member.status === 'ADMIN')
  const overflowCss = css`
    overflow-wrap: anywhere;
  `
  const smallSize = {
    labels: [
      `${t('user', 'User')}/${t('joined', 'Joined')}`,
      `${t('status.label', 'Status')}/${t('tree.column.mePerson', 'Me Person')}`,
      '',
    ],
    columnWidths: [5, 6, 1],
    combinationRules: [['column1', 'column2'], ['column3', 'column4'], ['column5']],
  }
  const defaultSize = {
    labels: [
      t('user', 'User'),
      t('joined', 'Joined'),
      t('status.label', 'Status'),
      t('tree.column.mePerson', 'Me Person'),
      '',
    ],
    columnWidths: [3, 3, 2, 3, 1],
    combinationRules: [['column1'], ['column2'], ['column3']],
  }

  const baseProps = {
    id: 'Group Members List',
    totalColumnCount: 5,
    atSizeColumns: {
      xs: smallSize,
      sm: smallSize,
      md: smallSize,
      lg: defaultSize,
      xl: defaultSize,
      xxl: defaultSize,
      default: defaultSize,
    },
  }

  const checkboxProps = {
    ...baseProps,
    onSelectionChange: setCheckedMembers,
  }

  const memberListItems = groupMembersState?.members?.map((member) => {
    const showDeleteButton = member.status === 'MEMBER' || groupMembersState.members.length === 1 || admins.length > 1
    const mePersonId = groupMembersState.mePersons?.userMePersonIds?.[member.memberCisId]
    return (
      <ResponsiveTableRow
        key={member.memberCisId}
        name={member.memberCisId}
        column1={
          <div css={overflowCss}>
            <CisLink userId={getIdElement(member.memberCisId)} userName={member.contactName} />
          </div>
        }
        column2={<div>{toLocaleString(new Date(member.createDate), false)}</div>}
        column3={<div>{t(`group.memberStatus.${member.status}`, member.status)}</div>}
        column4={
          mePersonId && (
            <div>
              <PersonLink personId={mePersonId} />
            </div>
          )
        }
        column5={
          isAuthorized('ModifyDataPermission') && (
            <>
              {member.status !== 'PENDING' && (
                <DemotePromoteMembersButton
                  members={[member]}
                  promoting={member.status === 'MEMBER'}
                  refreshData={refreshData}
                />
              )}
              {showDeleteButton && <DeleteGroupMembersButton members={[member]} refreshData={refreshData} single />}
            </>
          )
        }
      />
    )
  })
  return (
    <>
      {isAuthorized('ModifyDataPermission') ? (
        <DmcResponsiveCheckboxTable {...checkboxProps}>{memberListItems}</DmcResponsiveCheckboxTable>
      ) : (
        <DmcResponsiveTable {...baseProps}>{memberListItems}</DmcResponsiveTable>
      )}
    </>
  )
}
